export interface McpPreset {
  id: string;
  label: string;
  description: string;
  servers: string[] | '*';
  icon?: string;
}

export const MCP_PRESETS: McpPreset[] = [
  {
    id: 'all',
    label: 'All Tools',
    description: 'Enable all available MCP servers',
    servers: '*',
  },
  {
    id: 'research',
    label: 'Research',
    description: 'Web search, memory, and file access',
    servers: ['web-search', 'memory', 'filesystem'],
  },
  {
    id: 'code',
    label: 'Code',
    description: 'File system, git, GitHub, and execution',
    servers: ['filesystem', 'git', 'github-gh', 'exec'],
  },
  {
    id: 'minimal',
    label: 'Minimal',
    description: 'System info only - fast responses',
    servers: ['sysinfo'],
  },
  {
    id: 'none',
    label: 'None',
    description: 'Disable all MCP servers',
    servers: [],
  },
];

export function getPresetById(id: string): McpPreset | undefined {
  return MCP_PRESETS.find((p) => p.id === id);
}

export function matchPreset(
  enabledServers: string[],
  availableServers: string[]
): McpPreset | undefined {
  // Check if all servers are enabled
  if (
    enabledServers.length === availableServers.length &&
    availableServers.every((s) => enabledServers.includes(s))
  ) {
    return MCP_PRESETS.find((p) => p.id === 'all');
  }

  // Check if no servers are enabled
  if (enabledServers.length === 0) {
    return MCP_PRESETS.find((p) => p.id === 'none');
  }

  // Check for exact preset matches
  for (const preset of MCP_PRESETS) {
    if (preset.servers === '*' || preset.id === 'none') continue;

    const presetServers = preset.servers as string[];
    if (
      presetServers.length === enabledServers.length &&
      presetServers.every((s) => enabledServers.includes(s))
    ) {
      return preset;
    }
  }

  return undefined; // Custom configuration
}
